import { useEffect, useState } from "react";

import { queryNewsCategories } from "@api/news";

/**
 * 官网顶部「资讯」入口是否展示。
 *
 * 进入官网时先查询公开端分类接口：
 * - success 且 result 为非空数组 → 展示入口；
 * - 分类为空、success=false、请求失败 → 都按「没有分类数据」处理，隐藏入口。
 *
 * 默认 false，避免无资讯的站点先闪一下入口再消失。
 */
export default function useNewsEntryVisible(enabled = true) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // 后台预览不需要公开分类判断，避免预览时发起 /api/news 请求。
    if (!enabled) {
      setVisible(false);
      return undefined;
    }
    let alive = true;

    queryNewsCategories()
      .then((res) => {
        if (!alive) return;
        setVisible(
          Boolean(
            res?.success &&
              Array.isArray(res.result) &&
              res.result.length > 0
          )
        );
      })
      .catch(() => {
        if (alive) setVisible(false);
      });

    return () => {
      alive = false;
    };
  }, [enabled]);

  return visible;
}
